(function () {
  const GEO_KEY = "geoData";
  const DAYS = 30;
  const GEO_EXPIRY = DAYS * 24 * 60 * 60 * 1000;

  // const MINUTES = 5;
  // const GEO_EXPIRY = MINUTES * 60 * 1000;

  const FINAL_KEY = "ecomDecision";
  const DIS_MINUTES = 5; // 5  minutes
  const FINAL_EXPIRY = DIS_MINUTES * 60 * 1000; 
//   const FINAL_EXPIRY = 1 * 30


  // ================================
  // 1. GEO DATA (CACHE 30 DAYS) and if not persent than hit again to check ip
  function getGeoData() {
  const cached = localStorage.getItem(GEO_KEY);

      if (cached) {
        const parsed = JSON.parse(cached);

        // console.log("Now:", Date.now());
        // console.log("Saved:", parsed.timestamp);
        // console.log("Age:", Date.now() - parsed.timestamp);
        // console.log("Geo Expiry:", GEO_EXPIRY);

        if (Date.now() - parsed.timestamp < GEO_EXPIRY) {
          console.log("Using cached geo");
          return Promise.resolve(parsed.data);
        }

        console.log("Geo cache expired");
      }

  return fetch("https://ipapi.co/json/?key=LglOL7WuXk0cM86ZWyncZ6NNXIaorReZVQQK4jmfNaUs90srT9")
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      return res.json();
    })
    .then(data => {
      localStorage.setItem(
        GEO_KEY,
        JSON.stringify({
          data,
          timestamp: Date.now()
        })
      );
      console.log('Geo Api Data:', data)
      return data;
    })
    .catch(error => {
      console.warn("Geo lookup failed:", error);
      const decision = { action: "redirect" };
      saveDecision(decision);
      applyDecision(decision);
      console.log("Geo lookup failed");
      return null;
    });
}

  // 2. MATCH COUNTRY
  function getMatchedCountry(userCountry) {
    if (!window.ecommerceCountries) return null;
    let matchedCountry =  window.ecommerceCountries.find(
      item => item.country_code === userCountry
    );
    return window.ecommerceCountries = matchedCountry;
  }

  // 3. NORMALIZE STATES
  function normalizeStates(states) {
  if (!states) return [];

  // already array
  if (Array.isArray(states)) {
    return states.map(s => String(s).trim().toLowerCase());
  }

  // if JSON string
  try {
    const parsed = JSON.parse(states);
    if (Array.isArray(parsed)) {
      return parsed.map(s => String(s).trim().toLowerCase());
    }
  } catch (e) {}

  // fallback comma string
  return String(states)
    .split(",")
    .map(s => s.trim().toLowerCase())
    .filter(Boolean);
}

  // 4. UI HANDLERS
  function removeBuySection() {
    document.body.classList.add('ecommarce-atc-hide');
    const btn = document.querySelector('.buy-buttons');
    if (btn) {
    btn.style.setProperty('display', 'none');
    }
    document.querySelectorAll(
      '[data-block-type="price"], [data-block-type="quantity-selector"], [data-block-type="buy-buttons"], .buy-buttons, .price-list, .header__cart-link'
    ).forEach(el => el.remove());
  }

  function removeMultiButtonsParent() {
    document.body.classList.add('redirect-buttons-hide');
    document.querySelectorAll(`
      [data-block-type="quantity-selector"],
      [data-block-type="price"],
      .price-list,
      .header__cart-link
    `).forEach(el => {
      el.style.setProperty('display', 'block');
    });
    document.querySelectorAll(`
      .buy-buttons,
      .price-list,
      [data-block-type="buy-buttons"]
    `).forEach(el => {
      el.style.setProperty('display', 'flex');
    });

    // Enable Welcome Popup
    if(document.querySelector('.welcomePopMN')){
      document.querySelector('.welcomePopMN').removeAttribute('hidden');
    }

    // const btn = document.querySelector('.buy-buttons');
    // const qty = document.querySelector('[data-block-type="quantity-selector"]');
    // if (btn) {
    //   btn.style.setProperty('display', 'block');
    // }
    const qty = document.querySelector('.header__cart-link');
    if (qty) {
      qty.style.setProperty('display', 'block');
    }
    const multiBtn = document.querySelector(".multi_buttons");
    if (!multiBtn) return;

    const parent = multiBtn.closest('[data-block-type="button"]');
    if (parent) parent.remove();
  }

  // 5. DECISION CACHE (5 MIN)
  function saveDecision(data) {
    localStorage.setItem(
      FINAL_KEY,
      JSON.stringify({
        ...data,
        timestamp: Date.now()
      })
    );
  }

  function getSavedDecision() {
    const cached = localStorage.getItem(FINAL_KEY);
    if (!cached) return null;

    const parsed = JSON.parse(cached);

    if (Date.now() - parsed.timestamp < FINAL_EXPIRY) {
      return parsed;
    }

    return null;
  }

  function applyDecision(decision) {
    if (!decision) return;

    if (decision.action === "add") {
      removeMultiButtonsParent();
    }

    if (decision.action === "redirect") {
        const btn = document.querySelector('.redirect_buttons');
        if (btn) {
        btn.style.setProperty('display', 'flex');
        }
        removeBuySection();
         wrapShopOnlineButton(decision.redirect_url)
    }
  }

  function wrapShopOnlineButton(redirectUrl) {
      if (!redirectUrl) return;

      const container = document.querySelector('.multi_buttons');
      if (!container) return;

      const buttons = container.querySelectorAll('.button');

      // ensure second button exists
      if (buttons.length < 2) return;

      const btn = buttons[1]; // 👉 second button
      btn.onclick = function (e) {
        e.preventDefault();
        window.open(redirectUrl, "_blank");
      };

      // optional: add attribute for tracking/debug
      btn.setAttribute("data-redirect", "true");
      // console.log("Redirect added to second button");
  }

  // 6. MAIN LOGIC
  function runLogic(geo) {
    if (!geo) return;

    const userCountry = geo.country_code;
    const match = getMatchedCountry(userCountry);
    console.log('match', match);

    if (!match) {
      const decision = { action: "add" };
      saveDecision(decision);
      applyDecision(decision);
      return;
    }

    if(document.querySelectorAll('.dynamic_country').length > 0){
      document.querySelectorAll('.dynamic_country').forEach(function(element){
        element.innerHTML = match.country_name+'!';
      })
    }

    const enableB2C = match.enable_b2c === true || match.enable_b2c === "true";
    console.log('enableB2C', enableB2C);

    const statesList = normalizeStates(match.states);
    console.log('statesList', statesList);
    const userStateName = (geo.region || "").toLowerCase();

    // STATE PRIORITY
    if (statesList.length) {
        const stateMatch = statesList.includes(userStateName);

        if (stateMatch) {
            // 🔹 CASE 1: redirect URL exists → redirect
            if (match.redirect_url) {
                const decision = {
                    action: "redirect",
                    redirect_url: match.redirect_url
                };

                saveDecision(decision);
                applyDecision(decision);
                return;
            }

            // 🔹 CASE 2: redirect URL empty → allow ATC
            const decision = { action: "add" };
            saveDecision(decision);
            applyDecision(decision);
            return;
        }
    }
    // B2C LOGIC
    if (!enableB2C) {
        // 🔹 CASE 1: redirect URL exists → redirect
        if (match.redirect_url) {
            const decision = {
            action: "redirect",
            redirect_url: match.redirect_url
            };

            saveDecision(decision);
            applyDecision(decision);
            return;
        }

        // 🔹 CASE 2: redirect URL empty → allow redirect
        const decision = { action: "redirect" };
        saveDecision(decision);
        applyDecision(decision);
        return;
    }

    // B2C ENABLED
    const decision = { action: "add" };
    saveDecision(decision);
    applyDecision(decision);
  }

  function fetchCountry(country){
    if(document.querySelectorAll('.dynamic_country').length > 0){
      document.querySelectorAll('.dynamic_country').forEach(function(element){
        element.innerHTML = country+'!';
      })
    }
  }

  // 7. INIT
  function init() {
    if (!window.ecommerceCountries || !window.ecommerceCountries.length) {
      const decision = { action: "add" };
      saveDecision(decision);
      applyDecision(decision);
      console.warn("No metaobject data found");
      return;
    }

    // ✅ Apply cached decision first (no flicker)
    if(localStorage.getItem(GEO_KEY)){
      var cached_country = JSON.parse(localStorage.getItem(GEO_KEY)).data.country_name;
    }
    const saved = getSavedDecision();
    console.log('saved', saved);
    if (saved) {
      applyDecision(saved);
      if(localStorage.getItem(GEO_KEY)){
        fetchCountry(cached_country);
      }
      return;
    }
    console.log('3333');
    // ✅ Otherwise run logic
    getGeoData().then(geo => { runLogic(geo);});

  }

  document.addEventListener("DOMContentLoaded", init);
})();